import settings from './settings';

export const USER_DATA = 'zp_user_data';
export const AUTH_TOKEN = 'zp_auth_token';
export const IS_BO = settings.MODULE === 'BO';
export const IS_FO = settings.MODULE === 'FO';

export const DATE_FORMAT: string = 'dd.MM.yyyy';
export const DATE_FORMAT_EN: string = 'yyyy-MM-dd';
export const TIME_FORMAT: string = 'HH:mm';
export const DATETIME_FORMAT: string = 'dd.MM.yyyy HH:mm';
export const DATETIMESEC_FORMAT: string = 'dd.MM.yyyy HH:mm:ss';
export const MONTH_FORMAT: string = 'MM/yyyy';
